<template>
    <b-card title="Hücreler Arası Transfer">
        <b-overlay :show="loading" opacity="0.5" rounded="sm">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Kaynak Hücre">
                        <v-select
                            v-model="form.FromCellCode"
                            :options="cellOptions.filter((c) => c.CellCode !== (form.ToCellCode && form.ToCellCode.CellCode))"
                            label="CellName"
                            placeholder="Kaynak hücre seçin..."
                        />
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Stok Kodu">
                        <v-select v-model="form.StockCode" :options="stockOptions" label="StockCode" placeholder="Stok kodu seçin..." :disabled="!form.FromCellCode || stockOptions.length === 0">
                            <template #option="{ StockCode, Balance }"> {{ StockCode }} (Mevcut: {{ Balance }}) </template>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Hedef Hücre">
                        <v-select v-model="form.ToCellCode" :options="destinationCellOptions" label="CellName" placeholder="Hedef hücre seçin..." :disabled="!form.FromCellCode || !form.StockCode" />
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Miktar">
                        <b-form-input v-model.number="form.Quantity" type="number" placeholder="0" />
                        <b-form-text v-if="form.FromCellCode"> Mevcut: {{ availableQuantity }} adet </b-form-text>
                    </b-form-group>
                </div>
            </div>
            <div class="text-right mt-2">
                <button type="button" class="btn btn-primary" @click="transfer" :disabled="loading || !form.FromCellCode || !form.ToCellCode || !form.StockCode || !form.Quantity > 0">
                    <b-spinner v-if="loading" small class="mr-50" />
                    Transfer Et
                </button>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BOverlay, BFormGroup, BFormInput, BFormText, BSpinner } from "bootstrap-vue";
import { WarehouseApi } from "@/api/warehouse/index.js";

export default {
    name: "InternalTransferView",
    components: {
        BCard,
        BOverlay,
        BFormGroup,
        BFormInput,
        BSpinner,
        BFormText,
    },
    data() {
        return {
            loading: false,
            cellOptions: [],
            allBalances: [],
            stockOptions: [],
            availableQuantity: 0,
            form: {
                FromCellCode: null,
                ToCellCode: null,
                StockCode: null,
                Quantity: null,
            },
        };
    },
    computed: {
        destinationCellOptions() {
            if (!this.form.FromCellCode || !this.form.StockCode) {
                return [];
            }

            const sourceCellId = this.form.FromCellCode.Id;
            const stockToMove = this.form.StockCode.StockCode;

            const occupiedCells = new Map();
            this.allBalances.forEach((balance) => {
                if (balance.Balance > 0) {
                    if (!occupiedCells.has(balance.CellLocationId)) {
                        occupiedCells.set(balance.CellLocationId, []);
                    }
                    occupiedCells.get(balance.CellLocationId).push(balance.StockCode);
                }
            });

            return this.cellOptions.filter((cell) => {
                if (cell.Id === sourceCellId) return false;

                const occupants = occupiedCells.get(cell.Id);

                if (!occupants) {
                    return true;
                }

                if (occupants.length === 1 && occupants[0] === stockToMove) {
                    return true;
                }

                return false;
            });
        },
    },

    created() {
        this.fetchInitialData();
    },
    watch: {
        "form.FromCellCode"(selectedCell) {
            this.form.StockCode = null;
            this.form.Quantity = null;
            this.availableQuantity = 0;
            this.stockOptions = [];

            if (!selectedCell) return;

            this.stockOptions = this.allBalances.filter((b) => b.CellLocationId === selectedCell.Id);
        },
        "form.StockCode"(selectedStock) {
            this.form.Quantity = null;

            if (selectedStock) {
                this.availableQuantity = selectedStock.Balance;
            } else {
                this.availableQuantity = 0;
            }
        },
    },
    methods: {
        fetchInitialData() {
            this.loading = true;
            Promise.all([WarehouseApi.getAllCellLocations(), WarehouseApi.getListCellBalance({ StockCode: "" })])
                .then(([cellsResponse, balancesResponse]) => {
                    this.cellOptions = cellsResponse.data.Data.Items || [];
                    this.allBalances = balancesResponse.data.Data || [];
                })
                .catch((err) => this.$result(null, err))
                .finally(() => {
                    this.loading = false;
                });
        },
        transfer() {
            this.loading = true;

            const payload = [
                {
                    FromCellCode: this.form.FromCellCode ? this.form.FromCellCode.CellCode : "",
                    ToCellCode: this.form.ToCellCode ? this.form.ToCellCode.CellCode : "",
                    StockCode: this.form.StockCode ? this.form.StockCode.StockCode : "",
                    Quantity: this.form.Quantity,
                    CellTransferType: 2,
                },
            ];

            WarehouseApi.insertCellTransfer(payload)
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.form = { FromCellCode: null, ToCellCode: null, StockCode: null, Quantity: null };
                        this.fetchInitialData();
                    }
                })
                .catch((err) => this.$result(null, err))
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
